import type { DocumentNode } from 'graphql'

export interface SelectMenuOption {
  label: string
  value: string
}

export default function<TData, TVars, TMappedData>(
  query: DocumentNode,
  variables: ComputedRef<TVars> | TVars,
  transform: ({ data }: { data: TData | null }) => TMappedData,
  tags: undefined | string[] = undefined,
) {
  const { data, isFetching, execute } = useQuery<TData, TVars, TMappedData>(
    { query, variables, tags },
    transform,
  )

  async function search(q: string) {
    await execute({ variables: { ...unref(variables), term: q } })
    return data.value
  }

  return { data, isFetching, search }
}
